// Our own JSON.stringify replacement. This is needed so that we can generate correct Prisma Client queries

// Takes in an object like so:
// let obj = {
//     foo: "bar",
//     foo2: BigInt(1234),
//     foo3: false,
//     foo4: {
//       foo: BigInt(1),
//       foo2: "test",
//       foo3: {
//         foo: "bar",
//         foo2: 23
//       }
//     }
//   };
//
//   and converts it to this string:
//
// {
//   foo: "bar",
//   foo2: BigInt(1234),
//   foo3: false,
//   foo4: {
//     foo: BigInt(1),
//     foo2: "test",
//     foo3: {
//       foo: "bar",
//       foo2: 23,
//     },
//   },
// }

function indentation(depth: number): string {
  return Array(depth * 2)
    .fill(' ')
    .join('')
}

function stringifyScalar(
  scalar: string | number | boolean | bigint | Date | Buffer | Uint8Array
): string {
  if (typeof scalar === 'string') {
    return `"${scalar}"`
  } else if (typeof scalar === 'bigint') {
    return `BigInt(${scalar})`
  } else if (scalar instanceof Date) {
    return `"${scalar.toISOString()}"`
  } else if (scalar instanceof Buffer) {
    return `Buffer.from("${scalar.toString('base64')}", "base64")`
  } else if (scalar instanceof Uint8Array) {
    return `Buffer.from("${Buffer.from(scalar).toString('base64')}", "base64")`
  } else {
    return `${scalar}`
  }
}

export default function stringify(
  obj: any = undefined,
  depth: number = 1
): string {
  if (obj === undefined) {
    return 'undefined'
  }
  if (obj === null) {
    return 'null'
  } else if (
    obj instanceof Date ||
    obj instanceof Buffer ||
    obj instanceof Uint8Array ||
    typeof obj !== 'object'
  ) {
    return stringifyScalar(obj)
  } else if (Array.isArray(obj)) {
    return [
      '[',
      obj
        .map(v => [indentation(depth), stringify(v, depth + 1), ','].join(''))
        .join('\n'),
      indentation(depth - 1) + ']',
    ].join('\n')
  } else {
    return [
      `{`,
      Object.entries(obj)
        .map(([k, v]) =>
          [indentation(depth), k, ': ', stringify(v, depth + 1), ','].join('')
        )
        .join('\n'),
      indentation(depth - 1) + '}',
    ].join('\n')
  }
}
